import React, { useState, useEffect } from "react";
import { Box, Button } from "@mui/material";
import { useHistory } from "react-router-dom";
import ImageNavigationControls from "../../components/buttons/imageNavigationComponent/imageNavigationControls";
import Images from "../../assets";
import {useTranslation} from "react-i18next";
import {PAGE_HOME} from "../../locales/pages/namespaces";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";


const Hero = ({ title, header }) => {
  const history = useHistory();
  const [cur, setCur] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
    const { t } = useTranslation(PAGE_HOME);

    const IMAGES = [
        {
            src: Images.bannerNew1,
            pathname: "/products",
            title: "Brew",
            state: {
                categoryId: [24,25,26,27,28,29,30,31,32,33,34,35,36,37,38]
            },
        },
        {
            src: Images.bannerNew2,
            title: "Lunora",
            pathname: "/products",
            state: {
                categoryId: [39,46,52,57,58,40,41,42,43,44,45,47,48,49,50,51,53,56,59,60,61,62,54,55]
            },
        }
    ];

    const onPrev = () => setCur((c) => (c - 1 + IMAGES.length) % IMAGES.length);
  const onNext = () => setCur((c) => (c + 1) % IMAGES.length);
    const onViewProducts = () => {
        const { pathname, state } = IMAGES[cur];

        history.push({
            pathname,
            state,
        });
    };

  useEffect(() => {
    if (isPaused) return;
    const interval = setInterval(() => {
      setCur((prev) => (prev + 1) % IMAGES.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [isPaused]);

  const FADE_MS = 1300;

  return (
    <Box
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
      sx={{
        position: "relative",
        // height: { xs: 320, sm: 420, md: 577 },
        borderRadius: "30px",
        overflow: "hidden",
        display: "flex",
        alignItems: "flex-start",
        padding: { xs: "20px", sm: "40px", md: "60px" },
        width: "100%",
        //maxWidth: "1720px",
        mx: "auto",
      }}
    >
      {IMAGES.map((image, idx) => (
        <Box
          key={image.src}
          aria-hidden
          sx={{
            position: "absolute",
            inset: 0,
              objectFit:"contain",
            backgroundImage: `url('${image.src}')`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
            transition: `opacity ${FADE_MS}ms ease`,
            opacity: idx === cur ? 1 : 0,
            zIndex: 1,
            willChange: "opacity",
            transform: idx === cur ? "scale(1)" : "scale(1.02)",
            transitionProperty: "opacity, transform",
          }}
        />
      ))}

      <Box
        sx={{
          position: "absolute",
          inset: 0,
          zIndex: 2,
          pointerEvents: "none",
          backgroundImage:
            "linear-gradient(180deg, rgba(0,0,0,0.50) 18.75%, rgba(0,0,0,0.10) 100%)",
          backgroundRepeat: "no-repeat",
        }}
      />

      <Box
        sx={{
          position: "absolute",
          inset: 0,
          zIndex: 2,
          pointerEvents: "none",
          backgroundColor: "rgba(217,217,217,0.25)",
          mixBlendMode: "overlay",
        }}
      />

      <Box
        sx={{
          position: "relative",
          zIndex: 3,
          width: { xs: "100%", md: "50%" },
          maxWidth: { md: "520px" },
          color: "#fff",
        }}
      >
        <Box
          sx={{
            fontFamily: "'Roboto Condensed', Arial, sans-serif",
            fontSize: "14px",
            fontWeight: 700,
            lineHeight: "90%",
            letterSpacing: "0.7px",
            marginBottom: "20px",
            textTransform: "uppercase",
          }}
        >
          {header}
        </Box>

        <Box
          component="h1"
          sx={{
            color: "#F0F0F0",
            fontFamily: `"Zen Maru Gothic", sans-serif`,
            fontWeight: 900,
            textTransform: "uppercase",
            letterSpacing: "0px",
            margin: 0,
            marginBottom: "28px",
            width: "100%",
            maxWidth: { xs: "100%", md: "778px" },
            fontSize: { xs: 28, sm: 40, md: 64 },
            lineHeight: { xs: "1.0", md: "57.6px" },
            height: "116px",
            overflow: "hidden",
            whiteSpace: "normal",
            display: "block",
          }}
        >
            {IMAGES[cur].title}
        </Box>

        <Button
          variant="outlined"
          sx={{
            padding: "10px 28px",
            borderRadius: "24px",
            border: "none",
            color: "#2B3137",
            fontSize: 14,
            fontWeight: "900",
            marginTop: "18px",
          }}
          onClick={onViewProducts}
        >
            {IMAGES[cur].title === t('About us')? <ArrowForwardIcon/>:t("VIEW PRODUCTS")}
        </Button>
      </Box>

      {/* Navigation Controls on top */}
      <Box
        sx={{
          position: "absolute",
          right: "60px",
          top: "50%",
          transform: "translateY(-50%)",
          zIndex: 3,
          display: { xs: "none", md: "block" },
        }}
      >
        <ImageNavigationControls
          onPrev={onPrev}
          onNext={onNext}
          currentIndex={cur}
          totalItems={IMAGES.length}
        />
      </Box>
    </Box>
  );
};

export default Hero;
